module.exports = __webpack_public_path__ + "static/media/uk_flag.7a9d4c10.png";